import * as types from "_constants";

const initialState = {
  isLoading: true,
  plans: [],
  artwork: {},
  error: null
}

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.GET_PLANS_SUCCESS:
      console.log('payload', actions.payload);
      return {
        ...state,
        plans: actions.payload.plans,
        artwork: actions.payload.artwork || {},
        isLoading: false
      };

    case types.GET_PLANS_ERROR:
      return {
        ...state,
        error: actions.payload.error,
        isLoading: false
      };

    default:
      return state;
  }
}
